import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"]
  static values = { seconds: Number }

  connect() {
    if (!this.hasSecondsValue) return
    this.readyAt = Date.now() + this.secondsValue * 1000
    this.blockEarlyClick = (event) => { if (Date.now() < this.readyAt) event.preventDefault() }
    this.element.addEventListener("click", this.blockEarlyClick)
    this.updateCountdown()
    this.timer = setInterval(() => this.updateCountdown(), 1000)
  }

  updateCountdown() {
    const seconds = Math.max(0, Math.ceil((this.readyAt - Date.now()) / 1000))
    this.element.textContent = seconds > 0 ? `再送する（${seconds}秒後）` : "再送する"
    this.element.setAttribute("aria-disabled", String(seconds > 0))
    if (seconds === 0) clearInterval(this.timer)
  }

  preview(event) {
    const file = event.target.files?.[0]
    if (!file || !this.hasPreviewTarget) return
    if (!["image/jpeg", "image/png"].includes(file.type) || file.size > 5 * 1024 * 1024) {
      event.target.setCustomValidity("5MB以下のJPG・PNGを選択してください。")
      event.target.reportValidity()
      return
    }
    event.target.setCustomValidity("")
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = URL.createObjectURL(file)
    this.previewTarget.src = this.previewUrl
  }

  disconnect() {
    clearInterval(this.timer)
    if (this.blockEarlyClick) this.element.removeEventListener("click", this.blockEarlyClick)
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
  }
}
